import React, { useState } from 'react';
import { useTranslation } from '@common/hooks/translation';
import Tabs from '@common/components/tabs';
import NumericInput from '@common/components/numericInput';
import KeyboardInput from '@common/components/InputKeyboard';
import { playerSearchTabs, PlayerSearchTabTypes } from '@app/dev/constants/searchPlayer';

export const SearchPlayerStep = ({ form, setForm, errors, onClose }) => {
  const t = useTranslation();
  const [tab, setTab] = useState(
    form.searchType === 'username' ? PlayerSearchTabTypes.USERNAME : PlayerSearchTabTypes.PLAYER_ID,
  );

  const changeTab = (option) => {
    setTab(option.value);

    const nextSearchType = option.value === PlayerSearchTabTypes.PLAYER_ID ? 'playerId' : 'username';

    setForm((prevForm) => ({
      ...prevForm,
      searchType: nextSearchType,
      playerId: nextSearchType === 'playerId' ? prevForm.playerId : '',
      playerName: nextSearchType === 'username' ? prevForm.playerName : '',
    }));
  };


  const handleChange = (value) => {
    if (tab === PlayerSearchTabTypes.PLAYER_ID) {
      setForm((prevForm) => ({
        ...prevForm,
        playerId: value,
        playerName: '',
      }));
    } else {
      setForm((prevForm) => ({
        ...prevForm,
        playerName: value,
        playerId: '',
      }));
    }
  };

  return (
    <>
      {onClose && (
        <i
          onClick={onClose}
          className="global-icon icon-Close close-popup"
        />
      )}
      <p className="popup-title">{t('Deposit')}</p>
      <div className="popup-main-content">
        <p className="text-center">{t('Enter your player id or username')}</p>
        <Tabs value={tab} onChange={changeTab} options={playerSearchTabs} />

        {tab === PlayerSearchTabTypes.PLAYER_ID ? (
          <div className="deposit-popup-search-player-input input-wrapper">
            {errors.playerId && <p className="error-message">{t('Player id')}</p>}
            <div className="input-row">
              <NumericInput
                value={form.playerId || ''}
                onChange={handleChange}
                placeholder={t('Player id')}
              />
            </div>
            {errors.playerId && (
              <div className="error-message">{t(errors.playerId)}</div>
            )}
          </div>
        ) : (
          <div className="deposit-popup-search-player-input input-wrapper">
            {errors.playerName && <p className="error-message">{t('Player username')}</p>}
            <div className="input-row">
              <KeyboardInput
                type="text"
                disableSearchIcon
                value={form.playerName || ''}
                onChange={handleChange}
                placeholder={t('Username')}
              />
            </div>
            {errors.playerName && (
              <div className="error-message">{t(errors.playerName)}</div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

